/* eslint-disable react/prop-types */
import React, { useMemo, useState } from "react"
import { Paper } from "@material-ui/core"
import { useHistory } from "react-router-dom"

import PERMISSIONS_CODES from "constants/permission-codes"
import { ROUTE_RECEIPT_OF_INVOICE } from "constants/routeConstants"

import useShowSnackbar from "utils/snackbar-hooks"
import useCheckPermission from "utils/auth/useCheckPermission"
import {
  sendAndHandleInvalidToken,
  useWrapHandleInvalidToken,
} from "utils/invalid-token"

import ApiReceiptOfInvoice from "services/api-receipt-of-invoice"
import ApiCustomer from "services/api-customer"
import ApiInvoice from "services/api-invoice"

import NotAllowedNotice from "components/NotAllowedNotice"
import ReceiptOfInvoiceForm from "components/receipt-of-invoice/ReceiptOfInvoiceForm"

const PAGE_PERMISSIONS = [PERMISSIONS_CODES.WRITE_RECEIPT_OF_INVOICE]

const fetchCustomer = async () => ((await ApiCustomer.get()) || []).data

const fetchInvoiceData = async (customerId, searchText) =>
  (
    await ApiInvoice.get({
      customerId,
      searchText,
      fromColumns: ["invoiceNumber"],
      includeCanceled: false,
      limit: 10,
    })
  )?.data || []

function ReceiptOfInvoiceUpdatePage({ id, formData, setFormData, onSuccess }) {
  const history = useHistory()
  const [showSnackbar, showSnackbarLoading, hideSnackbar] = useShowSnackbar()
  const { checkWithoutUpdateState } = useCheckPermission()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const wrappedFetchCustomerData = useWrapHandleInvalidToken(
    fetchCustomer,
    () => []
  )

  const wrappedFetchInvoiceData = useWrapHandleInvalidToken(
    fetchInvoiceData,
    () => []
  )
  // const wrappedFetchAllInvoices = useWrapHandleInvalidToken(
  //   fetchAllInvoice,
  //   () => []
  // )
  const allowed = useMemo(
    () => checkWithoutUpdateState({ permissions: PAGE_PERMISSIONS }),
    [checkWithoutUpdateState]
  )

  const handleCancel = () => {
    history.push(ROUTE_RECEIPT_OF_INVOICE)
  }

  const handleSubmit = async (data) => {
    setIsSubmitting(true)
    showSnackbarLoading("Updating receipt of invoice...")

    let fetchState = {}

    try {
      fetchState = await sendAndHandleInvalidToken(() =>
        ApiReceiptOfInvoice.update(id, data)
      )
    } catch (err) {
      console.error(err)
      setIsSubmitting(false)
      showSnackbar(
        err?.errors?.[0]?.message ?? "Cannot update receipt of invoice."
      )
      return
    }

    if (fetchState.success) {
      const responseData = fetchState.response.data
      showSnackbar("Receipt of invoice successfully updated.")

      if (setFormData) {
        setFormData(responseData)
      }

      if (onSuccess) {
        onSuccess(responseData)
      }

      history.push(`${ROUTE_RECEIPT_OF_INVOICE}/${id}`)
    } else {
      setIsSubmitting(false)
      hideSnackbar()
    }
  }

  if (!allowed) {
    return (
      <Paper style={{ maxWidth: "800px" }}>
        <NotAllowedNotice />
      </Paper>
    )
  }

  return (
    <ReceiptOfInvoiceForm
      isUpdate
      isSubmitting={isSubmitting}
      defaultValue={formData}
      setFormData={setFormData}
      fetchCustomerData={wrappedFetchCustomerData}
      fetchInvoiceData={wrappedFetchInvoiceData}
      // fetchAllInvoices={wrappedFetchAllInvoices}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
    />
  )
}

export default ReceiptOfInvoiceUpdatePage
